import React from "react"
import { navigate, graphql, useStaticQuery } from "gatsby"
import minimatch from "minimatch"
import { AuthConfig } from "react-use-auth"
import { Auth0 } from "react-use-auth/auth0"
import Layout from "./components/layout"
import { ScopedRoute } from "./components/ScopedRoute"
import SCOPE_PAGE_MAP from "./constants/scopedRoutes"
import { getCustomNavKey } from "./util"

export { default as Layout } from "./components/layout"
export * from "./components/Blocks"
export { default as Note } from "./components/note"
// export { default as RecipeCard } from "./components/recipe-card"
// export { default as DemoProvider } from "./components/demo-provider"

const Default = ({ children, ...props }) => (
  <Layout
    authenticated={false}
    authorized={false}
    fullwidth={!getCustomNavKey(props)}
    {...props}
  >
    {children}
  </Layout>
)

const siteInfos = graphql`
  query {
    site {
      siteMetadata {
        title
        description
        siteUrl
        courseFirstLesson
        hasAuthentication
      }
    }
  }
`

const MyRouter = ({ element, ...props }) => {
  const {
    site: {
      siteMetadata: {
        title,
        description,
        siteUrl,
        courseFirstLesson,
        hasAuthentication,
      },
    },
  } = useStaticQuery(siteInfos)

  let authenticationElement = null
  if (hasAuthentication) {
    authenticationElement = (
      <AuthConfig
        navigate={navigate}
        authProvider={Auth0}
        params={{
          domain: process.env.GATSBY_AUTH0_DOMAIN,
          clientID: process.env.GATSBY_AUTH0_CLIENTID,
          scope: process.env.GATSBY_AUTH0_SCOPE,
          customPropertyNamespace:
            process.env.GATSBY_AUTH0_CUSTOMPROPERTYNAMESPACE,
        }}
      />
    )
  }

  props = {
    ...props,
    siteTitle: title,
    siteDescription: description,
    siteUrl,
    courseFirstLesson,
  }

  const scopedPages = Object.keys(SCOPE_PAGE_MAP)
  const scopedKey = scopedPages.find((page) => minimatch(props.path, page))

  if (scopedKey) {
    return (
      <>
        {authenticationElement}
        <ScopedRoute scopes={SCOPE_PAGE_MAP[scopedKey]} {...props}>
          {element}
        </ScopedRoute>
      </>
    )
  } else {
    return (
      <>
        {authenticationElement}
        <Default {...props}>{element}</Default>
      </>
    )
  }
}

export const wrapPageElement = ({ element, ...props }) => {
  return <MyRouter element={element} {...props} {...props.props} />
}
